import React, { Component, Suspense, lazy } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Spinner from "components/common/Spinner";
import FoldersMenu from "components/menu/file-manager/ume/folders-menu";
import FilesMenu from "components/menu/file-manager/ume/files-menu";
import UsersHasPermissions from "components/menu/file-manager/ume/users-has-permissions";
import { openCustomModal, closeCustomModal } from "components/custom/modals";

const ManageUsersModal = lazy(() =>
    import("components/menu/master-files/suppliers/manage-users-modal"));

class Index extends Component {
    permissionsWrapperHeight = 300;

    constructor(props) {
        super(props);

        this.handleManageUsersModal = this.handleManageUsersModal.bind(this);
    }

    handleManageUsersModal = () => {
        const modalObj = {
            id: "manage-users-modal",
            modalSettings: {
                size: "lg"
            },
            header: "User Management",
            children: (
                <Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <ManageUsersModal
                        onCancel={() => this.props.closeCustomModal(modalObj)}
                        supplierId={false}
                    />
                </Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const { loading } = this.props;

        return (
            <div className=" dashboard file-manager">
                <div className="row justify-content-end text-right p-2 bg-info">
                    <button
                        className="btn btn-warning"
                        onClick={this.handleManageUsersModal}
                    >
                        User Management
                    </button>
                </div>

                <div className="row position-relative">
                    {!loading || <Spinner />}

                    <div className="col-4 p-0 border border-dark file-manager-menu">
                        <div style={{
                            height: `calc(100% - ${this.permissionsWrapperHeight}px)`
                        }}>
                            <FoldersMenu />
                        </div>
                        <div style={{
                            height: `${this.permissionsWrapperHeight}px`
                        }}>
                            <UsersHasPermissions />
                        </div>
                    </div>
                    <div className="col-8 p-0 border border-dark border-left-0 file-manager-menu">
                        <FilesMenu />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.fileManager.loading,
});

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(Index);
